<template>
	<img :src="$store.state.moduleSetting.navbarColor === '#fff' ? logoDark : logoLight" class="" width="30" />
	<!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
</template>
<script>
export default {
	data() {
		return {
			logoLight: require("@/assets/images/pages/rutify/1-01.png"),
			logoDark: require("@/assets/images/pages/rutify/1-03.png"),
		};
	},
};
</script>
